module.exports = __webpack_public_path__ + "img/数据大屏.9ea2d2e0.png";